<template>
    <div style="background-color: #f8f9fa; min-height: 100vh;">
        <ClientDemoComponent/>
    </div>
</template>

<script>

import ClientDemoComponent from "../components/ClientComponents/ClientDataGraphComponent.vue";

export default {
  name: "client-demographics-view",
  components: { ClientDemoComponent },
  title: 'ClientDemographics',
}
</script>
